import { PageHeader } from '@platform/design-system';
import type { ReactNode } from 'react';
import { usePageContext } from '../usePageContext.ts';
import { isProductFiltered } from './performance.ts';
import { DashboardFilters, type DashboardFiltersProps } from './widgets/DashboardFilters.tsx';
import styles from './DashboardHeader.module.css';

export type DashboardHeaderProps = DashboardFiltersProps & { controls?: ReactNode };

export const DashboardHeader = ({ controls, ...filters }: DashboardHeaderProps) => {
  const { t } = usePageContext();
  return (
    <>
      <PageHeader
        title={t('dashboard.title')}
        action={
          <div className={styles['actions']}>
            <div className={styles['filters']}>
              <DashboardFilters {...filters} />
            </div>
            {controls}
          </div>
        }
      />
      {isProductFiltered(filters.productFilter) ? (
        <p className={styles['note']} role="note">
          {t('dashboard.filters.shopWideHidden')}
        </p>
      ) : null}
    </>
  );
};
